import { Component, OnInit } from '@angular/core';
import { ADPConfigService, ADPResourceService, CustomFormControl, ListItem } from 'digital-core';
import { StorageService } from '../../services/storage.service';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { PGHAppLoadService } from '../../services/pgh-app-load.service';
import { OktaAuthStateService } from '@okta/okta-angular';
import { PGHOktaService } from '../../services/pghokta.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footerSettings = [];
  year: number = 0;
  elitaEnvironments: ListItem[] = [];
  selectedElitaEnvironment: string;
  selectedProduct: string;
  isAdminSectionVisible: boolean = false;
  isAuthenticated = false;
  defaultElitaEnvironment: string;
  defaultProduct: string;
  isSPOEEnabled:boolean = false;

  public footerForm = new FormGroup({
    ElitaEnvironment: new CustomFormControl(),
    Theme: new CustomFormControl()
  });

  constructor(
    private oktaAuth: OktaAuthStateService,
    private pghOktaService: PGHOktaService,
    public resourceService: ADPResourceService,
    private storageService: StorageService,
    private configService: ADPConfigService,
    private appLoadService: PGHAppLoadService,
    private router: Router
  ) {
    this.oktaAuth.authState$.subscribe(authState => this.isAuthenticated = authState.isAuthenticated);
    if (this.storageService.getLocal('IsAdminSectionVisible')) {
      this.isAdminSectionVisible = this.storageService.getLocal('IsAdminSectionVisible');
    }
    if (this.storageService.getLocal('IsAdminSectionVisible')) {
      this.isAdminSectionVisible = this.storageService.getLocal('IsAdminSectionVisible');
    }
  }

  ngOnInit() {
    this.isAuthenticated = this.pghOktaService.isTokenValid();
    this.appLoadService.isSiteResourcesLoaded.subscribe(value => {
      if (value) {
        this.defaultElitaEnvironment = this.resourceService.getPortalSetting('Global_ElitaEnvironment')?.Value;
        if (this.defaultElitaEnvironment?.length) {
          this.storageService.setLocal(`elita-environment-default`, this.defaultElitaEnvironment);
        }
        this.getElitaEnvironments();
        this.resourceService.getPortalMenus('Footer_Menu').subscribe(data => {
          this.footerSettings = data.MenuItems;
        });
      }
    });

    this.year = new Date().getFullYear();
    this.setClientIds();
  }

  setClientIds() {
    var  ClientList :ListItem[] = [];
    ClientList.push(
      new ListItem('','2f8aae2b-90e3-408b-bcfb-aed5d3e7dda1', 'Directv')
    );
    ClientList.push(
      new ListItem('','8ac9629e-b935-4655-8e76-898b7f033575', 'Smart')
    );
    ClientList.push(
      new ListItem('','c1020e6c-a3d2-4d01-9176-7aed568b056f', 'TMO US')
    );
    ClientList.push(
      new ListItem('','2ddd897c-09e3-49ac-94cb-06f67d4fdd42','XFinity')
    );
    ClientList.push(
      new ListItem('','1dde1a09-6c1f-4d48-96d0-3224d1d539bb','TMO-AF')
    );
    ClientList.push(
      new ListItem('','7c00005f-859f-4891-b959-256128098790', 'DTE')
    );
    ClientList.push(
      new ListItem('','46e91365-1ad1-4a33-ba33-4dd3bed848ae', 'PGH-Org')
    );
    this.configService.setClientList(ClientList);
  }

  toggleDeveloperMode() {
    this.resourceService.isEditMode = !this.resourceService.isEditMode;
  }

  reloadSite() {
    this.resourceService.clearSiteResource().subscribe(response => {
      window.location.reload();
    });
  }

  setElitaEnvironment() {
    this.storageService.setLocal<string>(`elita-environment`, this.selectedElitaEnvironment);
    window.location.reload();
  }

  setDefaultElitaEnvironment() {
    const local = this.storageService.getLocal<string>(`elita-environment`);
    if (local) {
      this.footerForm.get('ElitaEnvironment').setValue(local);
      this.selectedElitaEnvironment = local;
    } else {
      this.footerForm.get('ElitaEnvironment').setValue(this.defaultElitaEnvironment);
      this.selectedElitaEnvironment = this.defaultElitaEnvironment;
    }
  }

  getSelectedElitaEnvironment() {
    return this.selectedElitaEnvironment || this.defaultElitaEnvironment;
  }

  getElitaEnvironments() {
    if (this.elitaEnvironments.length && this.selectedElitaEnvironment) {
      return;
    }

    this.setDefaultElitaEnvironment();

    this.resourceService.getListItemResource("Global_ElitaEnvironments").subscribe((data) => {
      if (data?.length) {
        this.elitaEnvironments = data;
        this.selectedElitaEnvironment = this.elitaEnvironments.find(x => x.Key.toLocaleLowerCase() === this.getSelectedElitaEnvironment().toLocaleLowerCase())?.Key;
        if (this.selectedElitaEnvironment) {
          this.storageService.setLocal(`elita-environment`, this.selectedElitaEnvironment);
        }
        if (this.selectedElitaEnvironment === null) {
          window.location.reload();
        }
      }
    });
  }

  toggleAdminSection() {
    this.isAdminSectionVisible = !this.isAdminSectionVisible;
    this.storageService.setLocal('IsAdminSectionVisible', this.isAdminSectionVisible);
  }

  showCMSPage(){
    this.router.navigateByUrl('/cms');
  }

  showEditorPage() {
    this.router.navigateByUrl('/editor');
  }
}
